<template>
    <section class="login-section">
        <div class="thumb-container absolute" :style="backgroundStyle"></div>
        <div class="container">
            <slot></slot>
        </div>
    </section>
</template>

<script setup>
    import { computed } from 'vue';

    // The layout only needs the theater background, so it takes it as a prop
    // instead of reaching into the store: a shared front layout must not know
    // global state.
    const props = defineProps({
        footer: {
            type: Object,
            required: true
        }
    });

    const backgroundStyle = computed(() => ({
        backgroundImage: `url(${props.footer.bg4_url})`
    }));
</script>
